/**
 * Worker API base URL。
 * - dev：留空字串（fetch 走相對路徑，由 vite proxy 轉到 8787）
 * - prod：build 時帶入 `VITE_API_BASE_URL=https://...workers.dev`
 */
export function apiBaseUrl(): string {
  return (import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/$/, '');
}
